import Vue from 'vue'
import router from './router'
import App from './App.vue'
import store from './store'
import Wallet from './plugins/Wallet'
import SnackBar from './plugins/SnackBar'
import smoothscroll from 'smoothscroll-polyfill'

smoothscroll.polyfill()

Vue.config.productionTip = false

Vue.use(Wallet)
Vue.use(SnackBar)

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
